import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestEmailReportLink } from './EmailReportLink.service';

export function useEmailReportLink() {
  return useMutation(getQuestEmailReportLink, {
    onSuccess() {
      notification.success({
        message: 'O relatório de Peça foi gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
